export const ALLOWED_EMAIL_DOMAINS_FOR_GUEST = [
  'gmail.com',
  'hotmail.com',
  'outlook.com',
  'icloud.com',
  'me.com',
  'yahoo.com',
  'googlemail.com',
  'protonmail.com',
  'hey.com',
  'hotmail.co.uk',
  'web.de',
  'proton.me',
  'gmx.de',
  'hotmail.fr',
  'live.com',
  'outlook.de',
  'mac.com',
  'pm.me',
  'yandex.ru',
  'aol.com',
  'mail.ru',
  'berkeley.edu',
  'yahoo.fr',
  'gmx.at',
  'msn.com',
  'outlook.fr',
  'ukr.net',
  'hotmail.de',
  'ymail.com',
  'live.co.uk',
  'comcast.net',
  'orange.fr',
  'live.nl',
  '163.com',
  't-online.de',
  'seznam.cz',
  'yahoo.co.uk',
  'rocketmail.com',
  'hotmail.ca',
  'bluewin.ch',
  'gmx.ch',
  'laposte.net',
  'qq.com',
  'hotmail.co.nz',
  'live.fr',
  'live.dk',
  'yandex.com',
  'aon.at',
  'live.se',
  'bk.ru',
  'wp.pl',
  'outlook.es',
  'wanadoo.fr',
  'live.it',
  'outlook.cz',
  'live.ca',
  'xtra.co.nz',
  'live.de',
  'hotmail.ch',
  'yahoo.ca',
  'live.ie',
  'naver.com',
  'yahoo.it',
  'live.cn',
  'online.de',
  'fastmail.com',
  'live.be',
  'sfr.fr',
  'post.cz',
  'yahoo.ro',
  'live.no',
  'outlook.pt',
  'free.fr',
  'btinternet.com',
  'sky.com',
  'email.cz',
  'yahoo.de',
  'hotmail.es',
  'xs4all.nl',
  'hotmail.it',
  'sent.com',
  'webflow.com',
  'proton.me',
  'pm.me',
];
